// extracted by mini-css-extract-plugin
export var active = "_ib-7";
export var blink = "_ib-8";
export var dropDownSelector = "_ib-4";
export var dropDownWrapper = "_ib-3";
export var fakeCursor = "_ib-6";
export var fontSizeButton = "_ib-9";
export var formQuillEditor = "_ib-0";
export var pressed = "_ib-a";
export var qlBlank = "_ib-1";
export var textFormattingToolbar = "_ib-2";
export var textToolbarOption = "_ib-5";